import bowser from 'bowser';
import { isbot } from 'isbot';

export interface IBrowserInfo {
	readonly osName: string | undefined;
	readonly osVersion: string | undefined;
	readonly browserName: string | undefined;
	readonly browserVersion: string | undefined;
	readonly platform: string | undefined;
	readonly isBot: boolean;
}

export class BrowserHelper {
	getBrowserInfo(userAgent: string): IBrowserInfo {
		const browser = bowser.parse(userAgent);

		if (!browser.browser.name) {
			return {
				browserName: userAgent.toLowerCase(),
				browserVersion: undefined,
				osName: undefined,
				osVersion: undefined,
				platform: undefined,
				isBot: true
			};
		}

		return {
			osName: browser.os.name?.toLowerCase(),
			osVersion: browser.os.version?.toLowerCase(),
			browserName: browser.browser.name?.toLowerCase(),
			browserVersion: browser.browser.version?.toLowerCase(),
			platform: browser.platform.type?.toLowerCase(),
			isBot: this.isBot(userAgent)
		};
	}

	isBot(userAgent: string): boolean {
		return isbot(userAgent);
	}

	getCurrentSubdomain(): string | undefined {
		try {
			const host = window.location.hostname;
			const parts = host.split('.');

			const subDomain = parts[0];

			if (!parts.length) {
				return;
			}

			return subDomain;
		} catch {
			// no need to do anything
			// this check may happen on server which is fine
			return undefined;
		}
	}
}

export const browserHelper = new BrowserHelper();
